var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Glyphs/Bulk Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Bulk-Edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-pen-checkmark",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 26 0 26 26 0 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.250000, 3.250000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04608333,15.1666667 L2.16666667,15.1666667 C0.969583333,15.1666667 0,14.1970833 0,13 L0,2.16666667 C0,0.969583333 0.969583333,0 2.16666667,0 L13,0 C14.1970833,0 15.1666667,0.969583333 15.1666667,2.16666667 L15.1666667,5.41666667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6738333,19.1511667 L20.2334167,12.5915833 C20.69925,12.12575 20.69925,11.37175 20.2334167,10.907 L18.343,9.01658333 C17.8771667,8.55075 17.1231667,8.55075 16.6584167,9.01658333 L10.0988333,15.5761667 C9.87458333,15.8004167 9.75,16.1026667 9.75,16.4179167 L9.75,19.5 L12.8320833,19.5 C13.1473333,19.5 13.4495833,19.3754167 13.6738333,19.1511667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "9.75 6.591 7.04166667 9.29933333 5.41666667 7.67433333"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkEdit);
export default __webpack_public_path__ + "static/media/bulk_edit.1d374d5b.svg";
export { ForwardRef as ReactComponent };